const FormatPhoneNumber = props => {
  const formatPhoneNumber = text => {
    if (!text) {
      return '';
    }

    if (text.search(/([33])\w/g) === 1) {
      return text
        .replace('+33', '0')
        .split('')
        .reduce((a, e, i) => a + e + ((i + 1) % 2 === 0 ? ' ' : ''), '');
    } else {
      return text.split('').reduce((a, e, i) => a + e + ((i + 1) % 2 === 0 ? ' ' : ''), '');
    }
  };

  return formatPhoneNumber(props.children);
};

export default FormatPhoneNumber;
